import { api } from '@/utils';

export default {
  name: 'FormControls',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    loading: false,
    apiVersion: 1,
    generalDossierInfo: undefined,
    clientInfo: undefined,
    genericFieldsInfo: undefined,
    timeEstimationsInfo: undefined,
    activityId: null,
    dossierId: null,
    cargoInfo: null,
    activityEventsInfo: null,
    linkDossierIdOnLoad: undefined,
    hintAlreadyDeleted: false,
    stakeholderReferences: null,
    alreadyPostedDossierId: 0,
  }),
  computed: {
    isDetail() {
      return this.$route.params.id != null;
    },
    canSendActivityEvents() {
      const canSendActivityEventsFormTypes = ['PortEngineArrival', 'Inspection'];
      return canSendActivityEventsFormTypes.includes(this.generalDossierInfo.type);
    },
  },
  methods: {
    // Buttons
    saveInputForm() {
      this.$eventHub.$emit('on-input-form-saved');

      // ToDo: kijken als dit beter kan
      setTimeout(() => {
        this.sendInputForm();
      }, 750);
    },
    relinkInputForm() {
      this.$eventHub.$emit('on-relink-input-form');
      setTimeout(() => {
        this.sendLink();
      }, 500);
    },
    cancelInputForm() {
      this.$router.push({ name: 'dossier-overview' });
    },
    // API methods
    sendInputForm() {
      if (this.generalDossierInfo != null
        && this.clientInfo != null
        && this.genericFieldsInfo != null
        && !(this.generalDossierInfo.type === 'CargoOperations' && this.cargoInfo == null)
        && this.cargoInfo !== false) {
        const postObject = this.buildPostObject();

        this.send(postObject);
      }
    },
    sendLink() {
      this.loading = true;

      // BASEURL
      const url = '/hints';

      const hintToDelete = this.inputForm.hints.filter(hint => hint.dossierId === this.linkDossierIdOnLoad)[0];

      this.loading = false;

      // delete the hint that is found upon inputForm loading
      if (hintToDelete !== undefined && !this.hintAlreadyDeleted) {
        this.alreadyPostedDossierId = hintToDelete.dossierId;
        api.delete(`${url}/${hintToDelete.id}`)
          .then(() => { this.hintAlreadyDeleted = true; })
          .catch((error) => {
            this.loading = false;
            this.$eventHub.$emit('show-snackbar', error);
            console.log(error);
          });
      }

      // if no dossier is selected do nothing
      if (this.dossierId !== null && this.alreadyPostedDossierId !== this.dossierId) {
        const postObject = {
          inputId: this.inputForm.id,
          dossierId: this.dossierId,
          activity: this.activityId,
        };

        api.post(url, postObject)
          .then(() => {
            this.loading = false;
            this.alreadyPostedDossierId = this.dossierId;
            this.$eventHub.$emit('show-snackbar', 'Input was relinked');
          })
          .catch((error) => {
            this.loading = false;
            this.$eventHub.$emit('show-snackbar', error);
            console.log(error);
          });
      } else {
        this.loading = false;
        this.$eventHub.$emit('show-snackbar', 'Input was relinked');
      }
    },
    send(postObject) {
      this.loading = true;

      // BASEURL
      const url = '/inputs?';

      api.post(url, postObject)
        .then((response) => {
          this.loading = false;
          this.$eventHub.$emit('show-snackbar', 'Input was created');
          this.$router.push({ name: 'input-form-with-id', params: { id: response.data.id } });
        })
        .catch((error) => {
          this.loading = false;
          this.$eventHub.$emit('show-snackbar', error);
          console.log(error);
        });
    },
    // Build post objects
    buildPostObject() {
      const postObject = {
        // General
        id: 0,
        createdOn: new Date().toISOString(),
        eventDateTime: new Date().toISOString(),
        inputType: this.generalDossierInfo.type,
        sourceType: this.generalDossierInfo.source,
        jobDate: this.generalDossierInfo.jobDate,
        sourceStakeholder: {
          id: this.generalDossierInfo.selectedSourceCompany.id,
          name: this.generalDossierInfo.selectedSourceCompany.name,
          reference: this.generalDossierInfo.sourceReference,
        },
        assigneeStakeholder: {
          id: this.generalDossierInfo.selectedCompany.id,
          name: this.generalDossierInfo.selectedCompany.name,
          reference: this.generalDossierInfo.reference,
        },
        // Client
        clientStakeholder: {
          id: this.clientInfo.selectedClient.id,
          name: this.clientInfo.selectedClient.name,
          // reference: does not exist
        },
        vesselIdentification: {
          vesselId: this.clientInfo.selectedVessel.id,
          vesselImo: this.clientInfo.selectedVessel.imo,
          vesselEni: this.clientInfo.selectedVessel.eni,
        },
        locationIdentification: {
          portLocode: 'BEANR',
          terminalCode: this.clientInfo.selectedTerminal.code,
          berthCode: this.clientInfo.selectedBerth,
        },
        cargoProductTypes: this.generalDossierInfo.cargoProductTypes,
        cargo: this.cargoInfo != null ? this.cargoInfo : [],
        // Generic fields
        properties: this.genericFieldsInfo,
        // Activity events
        activityEvents: this.canSendActivityEvents ? this.activityEventsInfo : [],
        // Time estimations info,
        dateTimeWindow1: this.timeEstimationsInfo.dateTimeWindow1,
        dateTimeWindow2: this.timeEstimationsInfo.dateTimeWindow2,
        // Activity & Dossier
        hints: [
          {
            activityId: this.activityId,
            dossierId: this.dossierId,
          },
        ],
        // stakeholder references
        additionalStakeholderReferences: this.stakeholderReferences,
      };

      if (this.dossierId === null) {
        postObject.hints = [];
      }

      return postObject;
    },
    // Fetch data out of outher components
    fetchGeneralDossierInfo(generalDossierInfo) {
      this.generalDossierInfo = generalDossierInfo;
    },
    fetchClientInfo(clientInfo) {
      this.clientInfo = clientInfo;
    },
    fetchGenericFieldsInfo(genericFieldsInfo) {
      this.genericFieldsInfo = genericFieldsInfo;
    },
    fetchTimeEstimationsInfo(timeEstimationsInfo) {
      this.timeEstimationsInfo = timeEstimationsInfo;
    },
    fetchDossierId(dossierId) {
      this.dossierId = dossierId;
    },
    fetchActivityId(activityId) {
      this.activityId = activityId;
    },
    fetchCargoInfo(cargoInfo) {
      this.cargoInfo = cargoInfo;
    },
    fetchActivityEventsInfo(activityEventsInfo) {
      this.activityEventsInfo = activityEventsInfo;
    },
    fetchStakeHolderReferences(stakeHolderReferences) {
      this.stakeholderReferences = stakeHolderReferences;
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm.link != null) {
        this.linkDossierIdOnLoad = this.inputForm.link.dossierId;
      } else if (this.inputForm.links.length > 0) {
        this.linkDossierIdOnLoad = this.inputForm.links[0].dossierId;
      }
    },
  },

  created() {
    this.$eventHub.$on('fetch-general-dossier-info', this.fetchGeneralDossierInfo);
    this.$eventHub.$on('fetch-client-info', this.fetchClientInfo);
    this.$eventHub.$on('fetch-generic-fields-info', this.fetchGenericFieldsInfo);
    this.$eventHub.$on('fetch-time-estimations-info', this.fetchTimeEstimationsInfo);
    this.$eventHub.$on('fetch-dossier-id', this.fetchDossierId);
    this.$eventHub.$on('fetch-activity-id', this.fetchActivityId);
    this.$eventHub.$on('fetch-cargo-info', this.fetchCargoInfo);
    this.$eventHub.$on('fetch-activity-events-info', this.fetchActivityEventsInfo);
    this.$eventHub.$on('fetch-stakeholder-references', this.fetchStakeHolderReferences);
  },
};
